<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.3147 9.69244C28.981 10.6672 28.8 11.7126 28.8 12.8C28.8 18.0992 33.1008 22.4 38.4 22.4C38.7885 22.4 39.1716 22.3769 39.5481 22.3319C39.8438 23.6407 40 25.0022 40 26.4C40 36.5568 31.7568 44.8 21.6 44.8C11.4432 44.8 3.19995 36.5568 3.19995 26.4C3.19995 16.2432 11.4432 8 21.6 8C24.3543 8 26.968 8.60623 29.3147 9.69244ZM27.2 20C27.2 16.9013 24.6986 14.4 21.6 14.4C18.5013 14.4 16 16.9013 16 20C16 23.0987 18.5013 25.6 21.6 25.6C24.6986 25.6 27.2 23.0987 27.2 20ZM21.9763 40.0941C17.1331 40.0941 12.9702 37.7994 9.59995 34.3216C9.65807 30.7541 18.1018 28.8 21.9763 28.8C25.8315 28.8 33.5418 30.7541 33.5999 34.3216C31.1009 37.7994 26.8195 40.0941 21.9763 40.0941Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.4001 12.8C30.4001 8.38405 33.9841 4.80005 38.4001 4.80005C42.8161 4.80005 46.4001 8.38405 46.4001 12.8C46.4001 17.216 42.8161 20.8 38.4001 20.8C33.9841 20.8 30.4001 17.216 30.4001 12.8ZM38.4001 16.6L43.2001 10.2L41.6001 9.00005L37.492 14.4776L35.1073 12.0929L33.693 13.5072L36.893 16.7072L37.7083 17.5225L38.4001 16.6Z"
      fill="#3EA827"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#6D202B",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
